import React from 'react';
import { baseXUnit } from '../../styles/theme';

const CardContainer: React.FunctionComponent<React.HTMLProps<HTMLDivElement>> =
  ({ children, ...rest }) => {
    if (!children) {
      return null;
    }

    return (
      <div className="card-container" data-testid="card-container" {...rest}>
        {children}
        {/*language=CSS*/}
        <style jsx global>{`
          .card-container {
            border: none;
            border-radius: ${baseXUnit(1)};
            box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);
          }
        `}</style>
      </div>
    );
  };

export default CardContainer;
